import gql from 'graphql-tag';
// Overall progress radial and per-curriculum progress bar chart
const GET_CURRICULUM_PROGRESS_REPORT = gql`
  query getPrmCurriculumProgressReport($where: PrmCurriculumProgressReportWhereInput!) {
    prmCurriculumProgressReport(where: $where) {
      overallProgressPercentage
      curriculums {
        productCurriculumId
        averageLessonAssignedCount
        averageLessonCompletedCount
        totalLessonCount
        productCurriculum {
          id
          code
          name
        }
      }
    }
  }
`;

export default GET_CURRICULUM_PROGRESS_REPORT;
